import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';

var _excluded = ["aria-label", "as", "children", "className", "corners", "data-testid", "onClick"];
var ActionArea = function ActionArea(_ref) {
  var ariaLabel = _ref['aria-label'],
    _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'button' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    corners = _ref.corners,
    dataTestId = _ref['data-testid'],
    onClick = _ref.onClick,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-ActionArea', _defineProperty({}, "--corners-".concat(corners), corners), className);
  var handleOnClick = function handleOnClick(event) {
    onClick && onClick(event);
  };
  // critical for good accessibility
  var getRole = function getRole() {
    if (As === 'button') {
      return 'button';
    } else if (As === 'a') {
      return 'link';
    } else {
      return 'navigation';
    }
  };
  return /*#__PURE__*/React__default.createElement(As, _extends({
    "aria-label": ariaLabel,
    className: finalClasses,
    role: getRole()
  }, otherProps, {
    "data-testid": dataTestId,
    onClick: handleOnClick
  }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children));
};
ActionArea.displayName = 'ActionArea';

export { ActionArea as default };
